import { AppModule } from "@/shared/app";
import { searchApp } from "../app";
import { RouteConfig } from "vue-router";

export const searchResultModule: AppModule = {
  app: searchApp,
  route: "wyniki",
  title: "Wyniki",
  iconClass: "fas fa-search fa-fw",
};

export const searchResultRouteConfig: RouteConfig = {
  meta: { module: searchResultModule },
  path: searchResultModule.route + "/:term",
  component: () => import("./SearchResultsView.vue"),
};
